module.exports = __webpack_public_path__ + "img/icon6.ed7c7428.svg";